import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Tooltip } from "antd";
import { USER_TYPE } from "constants/appConstant";
import { AuthInfo } from "stores/slices/auth";
import {
  doCreateDailyMessage,
  doDeleteDailyMessage,
  doGetDailyMessage,
  doUpdateDailyMessage,
} from "stores/slices/dailyMessage";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";
import EditorQuill from "components/inputs/editorQuill";

import { dailyMessage } from "./../../stores/slices/dailyMessage";

import styles from "./styles.module.scss";

// const { TextArea } = Input;
const MessageOfTheDay = props => {
  const {
    isVisbleModal,
    setisVisbleModal,
    inputText,
    setInputText,
    isUpdateDailyMessage,
    setIsUpdateDailyMessage,
    isShowDailyMessage = false,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const authInfo = useSelector(AuthInfo);
  const messageOfTheDay = useSelector(dailyMessage);
  const [isLoading, setisLoading] = useState(false);

  const onChangeText = value => {
    console.log("====================================");
    console.log("value", value);
    console.log("====================================");
    setInputText(value);
  };
  // const onChangeText = e => {
  //   setInputText(e.target.value);
  // };

  const handleGetDailyMessage = async () => {
    if (authInfo?.id) {
      await dispatch(doGetDailyMessage());
    }
  };

  const handleOpenEditModal = async () => {
    setIsUpdateDailyMessage(true);
    console.log("====================================");
    console.log("messageOfTheDay?.message", messageOfTheDay?.message);
    console.log("====================================");
    setInputText(messageOfTheDay?.message);
    setisVisbleModal(true);
  };

  const handleAddOrUpdateDailyMessage = async () => {
    if (authInfo?.type === USER_TYPE.SUPER_ADMIN) {
      let request = {};
      setisLoading(true);
      if (messageOfTheDay?.id) {
        request = {
          ...messageOfTheDay,
          message: inputText,
        };
        const { payload } = await dispatch(doUpdateDailyMessage(request));
        if (payload && payload.status === 200) {
          handleGetDailyMessage();
          setisLoading(false);
          setisVisbleModal(false);
        }
      } else {
        request = {
          message: inputText,
        };
        const { payload } = await dispatch(doCreateDailyMessage(request));
        if (payload && payload.status === 200) {
          handleGetDailyMessage();
          setisLoading(false);
          setisVisbleModal(false);
        }
      }
      setisLoading(false);
    }
  };

  const handleConfirmDeleteDailyMessage = async () => {
    Modal.confirm({
      title: t("dashboard.deleteMessageOfTheDay"),
      content: t("dashboard.deleteMessageOfTheDayMsg"),
      onCancel: () => {},
      onOk: async () => {
        await handleDeleteDailyMessage();
      },
    });
  };
  const handleDeleteDailyMessage = async () => {
    if (authInfo?.type === USER_TYPE.SUPER_ADMIN) {
      setisLoading(true);
      const { payload } = await dispatch(
        doDeleteDailyMessage({ id: messageOfTheDay && messageOfTheDay.id })
      );
      if (payload && payload.status === 200) {
        handleGetDailyMessage();
        setisLoading(false);
        setisVisbleModal(false);
      }
    }
  };

  useEffect(() => {
    handleGetDailyMessage();
  }, [authInfo?.id]);

  return (
    <>
      {messageOfTheDay && messageOfTheDay.message && isShowDailyMessage && (
        <>
          <div className={styles.messageContainer}>
            <div className={styles.messageTextContainer}>
              <EditorQuill
                readOnly={true}
                customStyle={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flex: 1,
                  maxHeight: "150px",
                  whiteSpace: "initial",
                  overflow: "auto",
                }}
                customClassName="customScrollbar borderNone"
                value={messageOfTheDay && messageOfTheDay.message}
              />

              {authInfo?.type === USER_TYPE.SUPER_ADMIN && (
                <>
                  <Space direction="horizontal" style={{ marginRight: 12 }}>
                    <Tooltip title={t("button.edit")}>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => handleOpenEditModal()}
                        disabled={isLoading}
                      />
                    </Tooltip>
                    {/* style={{ color: "#fff" }} */}
                    <Tooltip title={t("button.delete")}>
                      <Button
                        icon={<CloseOutlined />}
                        danger
                        type="link"
                        onClick={handleConfirmDeleteDailyMessage}
                        disabled={isLoading}
                      />
                    </Tooltip>
                  </Space>
                </>
              )}
            </div>
          </div>
        </>
      )}

      <ModalForm
        title={
          isUpdateDailyMessage
            ? t("dashboard.updateMessageOfTheDay")
            : t("dashboard.addMessageOfTheDay")
        }
        onCancel={() => setisVisbleModal(false)}
        onSubmit={() => setisVisbleModal(false)}
        destroyOnClose={true}
        isOpen={isVisbleModal}
        labelSubmit={t("button.save")}
        customWidth={700}
        footer={true}
        maskClosable={false}
      >
        {/* <TextArea
          value={inputText}
          onChange={onChangeText}
          placeholder="Input message of the day"
          autoSize={{
            minRows: 2,
            maxRows: 8,
          }}
          allowClear
        /> */}
        <EditorQuill
          placeholder={t("noticeBoard.textMessage")}
          onChange={value => {
            onChangeText(value);
          }}
          value={inputText}
          editorModulesCustom={editorModules}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "10px",
          }}
        >
          <AppButton
            label={t("label.cancel")}
            color={"grey"}
            disabled={isLoading}
            type="button"
            size={"minimum"}
            className={"cancelButton"}
            onClick={() => setisVisbleModal(false)}
          />
          <AppButton
            label={t("label.save")}
            color={"blue"}
            disabled={isLoading || !inputText}
            type="submit"
            size={"minimum"}
            onClick={handleAddOrUpdateDailyMessage}
          />
        </div>
      </ModalForm>
    </>
  );
};

export default MessageOfTheDay;

// const styles = {
//   messageContainer: {
//     padding: 8,
//     background:
//       "linear-gradient(212deg, rgb(58, 76, 232) 0%, rgb(31, 46, 180) 98.18%)",
//   },
//   messageTextContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//   },
//   messageText: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     fontSize: 14,
//     fontWeight: 500,
//     color: "#fff !important",
//     marginRight: 12,
//     flex: 1,
//   },
// };

const editorModules = () => {
  const colors = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466",
  ];
  return {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }, { size: [] }, { font: [] }],
      [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        { color: colors },
        { background: colors },
      ],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["clean"],
    ],
  };
};
